import * as React from 'react';
const TappoDiCerumeIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-2{fill:${primaryColor || '#282828'}}`}</style>
    </defs>
    <path
      d="m130.01 61.65-.04-.04a26.95 26.95 0 0 0-20.54-9.49c-14.87 0-26.98 12.11-26.98 26.98 0 4.75 1.25 9.41 3.61 13.49a2 2 0 0 0 2.71.73c.95-.55 1.28-1.77.73-2.72a23 23 0 0 1-3.08-11.5c0-12.68 10.33-23.01 23.01-23.01 6.75 0 13.13 2.95 17.51 8.08 4.96 6 7.36 13.48 7.35 22.85-1.56 18.53-7.29 24.91-15.97 34.58-4.3 4.78-9.16 10.2-14.39 18.1-2.07 2.67-5.18 4.21-8.56 4.21-5.95 0-10.79-4.85-10.79-10.8 0-1.09-.89-1.98-1.98-1.98s-1.99.89-1.99 1.98c0 8.14 6.62 14.77 14.76 14.77 4.64 0 8.91-2.12 11.73-5.8l.08-.11c5.1-7.71 9.88-13.03 14.1-17.73 8.89-9.89 15.31-17.04 16.97-36.96 0-.05.01-.1.01-.16.03-10.38-2.67-18.71-8.25-25.47"
      className="prefix__cls-2"
    />
    <path
      d="m85.18 97.95-5.25-.44v-1.03c0-1.1-.9-1.99-2-1.99s-2 .89-2 1.99v.96a9 9 0 0 0-4.62 2.23c-1.83 1.68-2.88 4.07-2.88 6.56s1.05 4.88 2.88 6.56c1.3 1.19 2.9 1.96 4.62 2.23v.96a2 2 0 1 0 4 0v-1.03l5.25-.44c4.34-.37 7.61-3.93 7.61-8.28s-3.27-7.91-7.61-8.28m-7.41 13.18c-1.39.12-2.73-.34-3.75-1.28-1.03-.94-1.59-2.23-1.59-3.62s.56-2.68 1.59-3.62c.92-.85 2.07-1.3 3.31-1.3.14 0 .29 0 .43.02l7.07.6c2.25.19 3.95 2.04 3.95 4.3s-1.7 4.11-3.95 4.3l-7.07.6Z"
      style={{
        fill: secondaryColor || '#ffcf38',
      }}
    />
    <path
      d="M124.82 74.97c-.99.47-2.18.04-2.65-.95-2.25-4.78-7.12-7.87-12.41-7.87-7.56 0-13.71 6.15-13.71 13.71 0 2.49.67 4.93 1.96 7.06 2.74-2.78 6.53-4.37 10.45-4.37 8.09 0 14.68 6.59 14.68 14.69s-6.59 14.68-14.68 14.68h-.3c-4.63 0-7.25 3.33-9.78 6.55-2.11 2.69-4.28 5.46-7.51 5.46-.42 0-.84-.05-1.27-.14-.49-.11-.95-.26-1.38-.46-.3-.13-.59-.29-.86-.48a2.009 2.009 0 0 1 2.23-3.28c.07.05.15.09.24.13.02.01.03.01.03.02.17.07.36.13.58.18 1.45.31 2.77-1.27 4.82-3.88 2.83-3.6 6.34-8.07 12.89-8.07h.31c5.9 0 10.71-4.81 10.71-10.71s-4.81-10.71-10.71-10.71c-3.57 0-6.89 1.76-8.89 4.72-.59.88-1.77 1.14-2.68.58a1.9 1.9 0 0 1-.54-.44c-2.76-3.2-4.27-7.3-4.27-11.53 0-9.75 7.93-17.68 17.68-17.68 6.82 0 13.1 3.98 16.01 10.15.46.99.04 2.18-.95 2.64"
      className="prefix__cls-2"
    />
    <path
      d="M88.22 123.33c-.33-.08-.62-.25-.86-.48.27.19.56.35.86.48"
      className="prefix__cls-2"
    />
  </svg>
);
export default TappoDiCerumeIcon;
